/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateStorefrontRemindersRequestInner
 */
export interface UpdateStorefrontRemindersRequestInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontRemindersRequestInner
     */
    type: UpdateStorefrontRemindersRequestInnerTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStorefrontRemindersRequestInner
     */
    smsEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStorefrontRemindersRequestInner
     */
    emailEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStorefrontRemindersRequestInner
     */
    whatsappEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontRemindersRequestInner
     */
    customText: string | null;
}


/**
 * @export
 */
export const UpdateStorefrontRemindersRequestInnerTypeEnum = {
    Confirmation: 'confirmation',
    Delivery: 'delivery',
    ReadyToPickup: 'ready_to_pickup',
    Reviews: 'reviews'
} as const;
export type UpdateStorefrontRemindersRequestInnerTypeEnum = typeof UpdateStorefrontRemindersRequestInnerTypeEnum[keyof typeof UpdateStorefrontRemindersRequestInnerTypeEnum];


/**
 * Check if a given object implements the UpdateStorefrontRemindersRequestInner interface.
 */
export function instanceOfUpdateStorefrontRemindersRequestInner(value: object): value is UpdateStorefrontRemindersRequestInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('smsEnabled' in value) || value['smsEnabled'] === undefined) return false;
    if (!('emailEnabled' in value) || value['emailEnabled'] === undefined) return false;
    if (!('whatsappEnabled' in value) || value['whatsappEnabled'] === undefined) return false;
    if (!('customText' in value) || value['customText'] === undefined) return false;
    return true;
}

export function UpdateStorefrontRemindersRequestInnerFromJSON(json: any): UpdateStorefrontRemindersRequestInner {
    return UpdateStorefrontRemindersRequestInnerFromJSONTyped(json, false);
}

export function UpdateStorefrontRemindersRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStorefrontRemindersRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'smsEnabled': json['smsEnabled'],
        'emailEnabled': json['emailEnabled'],
        'whatsappEnabled': json['whatsappEnabled'],
        'customText': json['customText'],
    };
}

export function UpdateStorefrontRemindersRequestInnerToJSON(json: any): UpdateStorefrontRemindersRequestInner {
    return UpdateStorefrontRemindersRequestInnerToJSONTyped(json, false);
}

export function UpdateStorefrontRemindersRequestInnerToJSONTyped(value?: UpdateStorefrontRemindersRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'smsEnabled': value['smsEnabled'],
        'emailEnabled': value['emailEnabled'],
        'whatsappEnabled': value['whatsappEnabled'],
        'customText': value['customText'],
    };
}

